import type { Producto, Zona } from '../types/pedido'

const IMG = {
  b20: 'https://cdn.magicpatterns.com/patterns/generated-images/464773d4-2632-4450-b5db-096ad61f7d1c.jpg',
  b10: 'https://cdn.magicpatterns.com/patterns/generated-images/e2dc2698-82b8-48f4-ab67-d00ef3d1529d.jpg',
  b6: 'https://cdn.magicpatterns.com/patterns/generated-images/5b68c1c2-5b7f-4731-8feb-3878356fee3d.jpg',
  iso10: 'https://cdn.magicpatterns.com/patterns/generated-images/96ba73a8-9028-4673-9da0-2ffdbe219b82.jpg',
  hip10: 'https://cdn.magicpatterns.com/patterns/generated-images/86a93b6f-88d6-4930-ae69-fe3f8ed22afe.jpg',
  logo: 'https://cdn.magicpatterns.com/patterns/generated-images/1c694cdf-6a89-44da-9c7e-fc453516fcaa.jpg',
}

export const CONFIG = {
  negocio: 'Acqualina',
  bajada: 'Agua purificada y agua de mar a domicilio · Distribuidor oficial Zona Norte',
  distribuidor: 'Eduardo Brussa · Zona Norte GBA',
  logo: IMG.logo,

  /** Formato internacional, sin +, sin espacios y sin el 15. */
  whatsapp: '5491159903399',

  /** URL del Apps Script. Vacío = modo demo (no envía nada). */
  apiUrl: '',

  /** $ mínimo para poder confirmar (0 = sin mínimo). */
  pedidoMinimo: 0,

  /** Después de esta hora, el pedido pasa a la próxima vuelta. */
  horaCorte: 9,

  /** Sellos por categoría. Tienen que ser ciertos para TODOS sus productos. */
  categoriaSellos: {
    'Agua para tomar': ['Agua alcalina', 'Baja en sodio', 'Sin metales pesados'],
  } as Record<string, string[] | undefined>,

  productos: [
    { id: 'b20', categoria: 'Agua para tomar', nombre: 'Bidón 20 L', detalle: 'Retornable · devolvés el envase vacío', precio: 14000, imagen: IMG.b20 },
    { id: 'b10', categoria: 'Agua para tomar', nombre: 'Bidón 10 L · Agua de mesa', detalle: 'Descartable', precio: 9000, imagen: IMG.b10 },
    { id: 'b6', categoria: 'Agua para tomar', nombre: 'Bidón 6 L', detalle: 'Descartable', precio: 6000, imagen: IMG.b6 },

    { id: 'iso10', categoria: 'Agua de mar isotónica · Acquamarina', nombre: 'Bidón 10 L · Isotónica', precio: 18000, imagen: IMG.iso10 },

    { id: 'hip500', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Botella 500 cc', precio: 5000 },
    { id: 'hip1l', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Botella 1 L', precio: 7000 },
    { id: 'hip5', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Bidón 5 L', precio: 17000 },
    { id: 'hip10', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Bidón 10 L · Hipertónica', precio: 28000, imagen: IMG.hip10 },
    { id: 'spray', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Spray Marino 30 ml', precio: 4000 },
    { id: 'sal', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Sal marina 120 g', precio: 8000 },
    { id: 'salmuera', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Salmuera Gourmet Spray', precio: 11000 },
    { id: 'ormus', categoria: 'Agua de mar hipertónica · Biendemar', nombre: 'Ormus Etergolds Gold', precio: 26000 },
  ] as Producto[],

  /** dia: 1=lunes … 6=sábado. Un barrio puede tener más de un día. */
  zonas: [
    { barrio: 'Saavedra', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Villa Pueyrredón', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'San Martín', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'San Andrés', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Villa Maipú', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Villa Urquiza', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Munro', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Villa Adelina', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Carapachay', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'José León Suárez', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },
    { barrio: 'Boulogne', entregas: [{ dia: 2, ruta: 'Saavedra / San Martín' }] },

    { barrio: 'Santos Lugares', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'Villa Lynch', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'Martín Coronado', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'Caseros', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'Villa Ballester', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'Villa Bosch', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'Sáenz Peña', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },
    { barrio: 'El Palomar', entregas: [{ dia: 2, ruta: 'Tres de Febrero' }] },

    { barrio: 'Tigre', entregas: [{ dia: 3, ruta: 'Tigre' }] },
    { barrio: 'San Fernando', entregas: [{ dia: 3, ruta: 'Tigre' }] },
    { barrio: 'Victoria', entregas: [{ dia: 3, ruta: 'Tigre' }] },
    { barrio: 'Virreyes', entregas: [{ dia: 3, ruta: 'Tigre' }] },
    { barrio: 'Beccar', entregas: [{ dia: 3, ruta: 'Tigre' }] },

    { barrio: 'San Isidro', entregas: [{ dia: 4, ruta: 'San Isidro' }] },
    { barrio: 'Acassuso', entregas: [{ dia: 4, ruta: 'San Isidro' }] },
    { barrio: 'Martínez', entregas: [{ dia: 4, ruta: 'San Isidro' }] },

    { barrio: 'La Lucila', entregas: [{ dia: 5, ruta: 'Vicente López' }] },
    { barrio: 'Vicente López', entregas: [{ dia: 5, ruta: 'Vicente López' }] },
    { barrio: 'Florida', entregas: [{ dia: 5, ruta: 'Vicente López' }] },
    { barrio: 'Villa Martelli', entregas: [{ dia: 5, ruta: 'Vicente López' }] },

    {
      barrio: 'Olivos',
      entregas: [
        { dia: 4, ruta: 'San Isidro' },
        { dia: 5, ruta: 'Vicente López' },
      ],
    },
  ] as Zona[],
}
